export default "__VITE_ASSET__Bek8dO0T__"